import getTomorrow from "./getTomorrow";

const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

const formatDate = (date, nextDay) => { 
  // takes date and transform it to  Day, Month 12th 
     if(nextDay) date = getTomorrow()
    let dayNumber = date.getDate()
    if(dayNumber == 1){
         dayNumber += 'st'
        }
    else if(dayNumber == 2) {
        dayNumber += 'nd'
    }else{ 
        dayNumber += 'th'
    }
    
    let month = date.getMonth()
    month = months[month]
    
    let day = date.getDay() 
    day = days[day]

    return `${day}, ${month} ${dayNumber}`
}


export default formatDate